<template>

    <div>

        <el-dialog :title="title" width="80%" :visible="addsubRecordDialogVisible" @close="close" center>

            <el-row class="bottom20">
                <el-table :data="fixedTableData" stripe style="width: 100%">
                    <el-table-column prop="config.desc" label="项目">
                    </el-table-column>
                    <el-table-column prop="content" label="分值">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.score" @keyup.native="handleScoreInput(scope.row, 'score')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="评分备注">
                        <template slot-scope="scope">
                            <el-input type="textarea" v-model="scope.row.remark" maxlength="1000"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>

            <el-row style="text-align: center">
                <el-button center="true" type="primary" @click="save()">确 定</el-button>
                <el-button center @click="close()">关 闭</el-button>
            </el-row>

        </el-dialog>

    </div>

</template>

<script>
    import AssessmentServer from "../../../api/assessment";

    export default {
        name: "addsubRecordDialog",

        props: ['addsubRecordDialogVisible', 'tableData', 'title'],

        methods: {

            save() {

                //处理减分项分值，加上负号
                let tmpTableData = JSON.parse(JSON.stringify(this.fixedTableData));
                tmpTableData = tmpTableData.map(e => {
                    e.changeby = localStorage.getItem("realname");
                    if (this.title == '减分项') {
                        e.score = 0 - Number.parseFloat(e.score);
                    }
                    return e;
                });

                AssessmentServer.addsubRecord.batchUpdate(tmpTableData).then(responseBody => {
                    this.$message.success("保存成功");
                    this.close();
                });

            },

            close() {
                // this.$emit('update:addsubRecordDialogVisible', false);
                this.$emit('afterCloseAddsubRecordDialog');
            },

            handleScoreInput(row, property) {
                try {
                    row[property] = row[property].match(/\d*(\.?\d{0,1})/g)[0];
                    // row[property] = row[property].match(/^-?\d*(\.?\d{0,1})/g)[0];
                } catch (e) {
                    console.warn(e);
                }
            },

        },

        computed: {

            //处理减分项分值，去掉负号
            fixedTableData() {
                let tmpTableData = JSON.parse(JSON.stringify(this.tableData));
                if (this.title == '减分项') {
                    tmpTableData.map(e => {
                        e.score = 0 - Number.parseFloat(e.score);
                        return e;
                    });
                }
                return tmpTableData;
            },

        },

    }
</script>

<style scoped>

</style>